import { INTEGRATE_SUPPORTER_ACCOUNTS } from 'actions/supporters'
import { UPDATE_TRACKED_ACCOUNT } from 'actions/trackedAccounts'
import { SIGN_IN } from 'actions/auth'
import { REFRESH_USER_DATA } from 'actions/users'
import { RECONNECT_TRACKED_ACCOUNT_PROVIDER } from 'actions/trackedAccountProviders'
import update from 'immutability-helper'

const setTrackedAccounts = (state, action) => action.payload.data.entities.trackedAccounts

const setTrackedAccountsForProvider = (state, { payload: { data: { result: trackedAccountProviderId, entities: { trackedAccounts, archivedTrackedAccounts } } } }) => {
  const allAccounts = { ...state }
  for(const accountId in allAccounts) {
    if (allAccounts[accountId].trackedAccountProviderId === trackedAccountProviderId && !trackedAccounts[accountId]) {
      delete allAccounts[accountId]
    }
  }
  return { ...allAccounts, ...trackedAccounts }
}

const updateTrackedAccount = (state, { payload: { data: { result: trackedAccountId, entities: { trackedAccounts } } } }) => (
  update(state, { [trackedAccountId]: { $set: trackedAccounts[trackedAccountId] } })
)

const handlers = {
  [`${INTEGRATE_SUPPORTER_ACCOUNTS}_FULFILLED`]: setTrackedAccounts,
  [`${UPDATE_TRACKED_ACCOUNT}_FULFILLED`]: updateTrackedAccount,
  [`${SIGN_IN}_FULFILLED`]: setTrackedAccounts,
  [`${REFRESH_USER_DATA}_FULFILLED`]: setTrackedAccounts,
  [`${RECONNECT_TRACKED_ACCOUNT_PROVIDER}_FULFILLED`]: setTrackedAccountsForProvider
}

export default function trackedAccountsReducer (state = {}, action) {
  const handler = handlers[action.type]
  return handler ? handler(state, action) : state
}
